import { InvalidStateError } from '#common/types';
import { createAzureSasConfig, createAzureStoreWithSasTokens } from './azure';
import { createS3Config, createS3Store } from './s3';
import { ObjectStoreType } from './types';
export function buildClientObjectStore(params) {
    switch (params.type) {
        case ObjectStoreType.S3:
            return createS3Store(createS3Config(params.config, params.stsContext));
        case ObjectStoreType.AZURE:
            return createAzureStoreWithSasTokens(createAzureSasConfig(params.config, params.sasContext));
        default:
            throw new InvalidStateError(`Invalid object store type: ${params.type}!`);
    }
}
